module.exports = "/_next/static/images/los-angeles-fast-channel-description-image-black-letters-f741b7c43834fcbce4f6eb33cd0e90f8.svg";